<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2c"><a id="page_v"></a><a id="contents">Contents</a></h2><a id="contents">
</a><p class="tocsec"><a id="contents"></a><a class="nounder" href="#/xhtml/prologue#prologue">Prologue</a></p>
<p class="tocpart"><a class="nounder" href="#/xhtml/part01#part01"><span class="small">PART ONE</span></a></p>
<p class="tocchap"><a class="nounder" href="#/xhtml/ch01#ch01">1 ‘Would You Like to Join the Army?’</a></p>
<p class="tocchap"><a class="nounder" href="#/xhtml/ch02#ch02">2 ‘Their Tax in Blood’</a></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch03#ch03" title="Link target outside of Sample">3 ‘They Threw Us In’</span></p>
<p class="tocpart"><span class="nounder" href="#/xhtml/part02#part02" title="Link target outside of Sample"><span class="small">PART TWO</span></span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch04#ch04" title="Link target outside of Sample">4 Blitzkrieg</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch05#ch05" title="Link target outside of Sample">5 ‘They Just Kept Marching Us’</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch06#ch06" title="Link target outside of Sample">6 ‘A Ring of Steel and Fire’</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch07#ch07" title="Link target outside of Sample">7 Dynamo</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch08#ch08" title="Link target outside of Sample">8 ‘Just Follow the Ferries’</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch09#ch09" title="Link target outside of Sample">9 ‘Blood All Over Your Hands’</span></p>
<p class="tocchap1"><span class="nounder" href="#/xhtml/ch10#ch10" title="Link target outside of Sample">10 ‘The Hour Is Too Solemn’</span></p>
<p class="tocchap1"><a id="page_vi"></a><span class="nounder" href="#/xhtml/ch11#ch11" title="Link target outside of Sample">11 ‘What Have We Let Ourselves In For?’</span></p>
<p class="tocchap1"><span class="nounder" href="#/xhtml/ch12#ch12" title="Link target outside of Sample">12 ‘I’ll Come Looking for You!’</span></p>
<p class="tocchap1"><span class="nounder" href="#/xhtml/ch13#ch13" title="Link target outside of Sample">13 Remote in Some Dream of Pain</span></p>
<p class="tocchap1"><span class="nounder" href="#/xhtml/ch14#ch14" title="Link target outside of Sample">14 ‘Beyond the Limits of Endurance’</span></p>
<p class="tocpart"><span class="nounder" href="#/xhtml/part03#part03" title="Link target outside of Sample"><span class="small">PART THREE</span></span></p>
<p class="tocchap1"><span class="nounder" href="#/xhtml/ch15#ch15" title="Link target outside of Sample">15 The Spontaneous Legend</span></p>
<p class="tocchap1"><span class="nounder" href="#/xhtml/ch16#ch16" title="Link target outside of Sample">16 ‘Very Well – Alone’</span></p>
<p class="tocchap1"><span class="nounder" href="#/xhtml/ch17#ch17" title="Link target outside of Sample">17 The Guilt and the Wonder</span></p>
<p class="tocchap1"><span class="nounder" href="#/xhtml/ch18#ch18" title="Link target outside of Sample">18 The Moment of Dunkirk</span></p>
<p class="tocapp1"><span class="nounder" href="#/xhtml/notes#notes" title="Link target outside of Sample"><em>Notes</em></span></p>
<p class="tocapp"><span class="nounder" href="#/xhtml/acknow#acknow" title="Link target outside of Sample"><em>Acknowledgements</em></span></p>
<p class="tocapp"><span class="nounder" href="#/xhtml/further#further" title="Link target outside of Sample"><em>Selected Further Reading</em></span></p>
<p class="tocapp"><span class="nounder" href="#/xhtml/index#index" title="Link target outside of Sample"><em>Index</em></span></p>
<p class="tocapp"><span class="nounder" href="#/xhtml/photo" title="Link target outside of Sample"><em>Photographs</em></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?389f1eba